// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1ZS4Q","label":"SetPasswdForm_label__3y9q8"};